import { NavLink } from "react-router-dom";
import { HR_NAV } from "@/components/layout/navConfig";
import { canSeeTeamBoard } from "./logbookUtils";

// Tabs across the top of every HR page: HR App (Quickair HR) and Logbook's
// My Tasks / Assigned by Me / Team Board / Assign Task / Logbook Admin.
// With `me` (the user's Logbook employee) known, Team Board and Logbook Admin
// are shown only to those who can use them, as in Logbook's own app.
const HIDE = {
  "/hr/logbook/team": (me) => !canSeeTeamBoard(me),
  "/hr/logbook/admin": (me) => !me.isAdmin,
};

export default function HrTabs({ me }) {
  const tabs = HR_NAV.filter((t) => !me || !HIDE[t.to]?.(me));
  return (
    <nav className="flex gap-1 overflow-x-auto border-b border-slate-200" aria-label="HR" data-testid="hr-tabs">
      {tabs.map((t) => (
        <NavLink key={t.to} to={t.to} end={t.to === "/hr"} data-testid={t.tid}
          className={({ isActive }) => `px-3 py-2 text-sm whitespace-nowrap -mb-px border-b-2 ${isActive ? "border-blue-600 text-blue-700 font-medium" : "border-transparent text-slate-600 hover:text-slate-900"}`}>
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
